// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"9d6c7b86","239":"03ec2f51","666":"08df4c0d","886":"f8b9cfce"}[chunkId] + ".chunk.css";
};